import React, { Component } from 'react';
import Select from 'react-select';

import './../scss/Search.scss';
import LocalCountryPage from './LocalCountryPage';
import PropTypes from 'prop-types';
import { countryList } from '../data/country-list';

const { __ } = window.wp.i18n;

const customStyles = {

  option: (provided, state) => ({
    ...provided,
    border: '0',
    borderRadius: '0',
    fontSize: '14px',
    backgroundColor: 'white',
    color: state.isFocused ? '#0070ad' : '#15011d',
    padding: '8px 16px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  }),

  control: (provided, state) => ({
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '0',
    borderBottom: '1px solid #15011d',
    backgroundColor: state.isFocused ? 'white' : '#ececec',
    transition: 'all .5s ease-in-out',
    padding: '12px 16px',
    fontSize: '16px'
  }),

  multiValue: base => ({
    ...base,
    border: '0px',
    backgroundColor: '#0070AD',
    fontSize: '16px',
    color: 'white'
  }),

  multiValueLabel: base => ({
    ...base,
    color: 'white'
  }),

  multiValueRemove: (base, state) => ({
    ...base,
    '&:hover': {
      backgroundColor: '#0070AD',
      color: 'white',
      cursor: 'pointer'
    }
  }),

  MultiValueContainer: (base, state) => ({
    ...base,
    position: 'absolute',
    top: '30px',
    padding: '10px 8px'
  }),

  valueContainer: (base) => ({
    ...base,
    padding: '0px'
  }),

  placeholder: (base) => ({
    ...base,
    position: 'static',
    fontSize: '16px',
    transform: 'none',
    color: '#15011d',
    font: '400 15px/1.5 Ubuntu,sans-serif'
  })
};

class Search extends Component {
  state = {
    keyword: '',
    // Countries
    countryCode: '',
    countryName: '',
    // Experience Level
    experience_level: '',
    // Department
    department: '',
    // Contract type
    contract_type: '',
    // Business Units
    business_units: '',
    // Location
    location: '',
    // professional communities
    professional_communities: '',
    // brand
    brand: '',
    size: 15,
    // Removed tags
    removed_tags: [],

    showCallToAction: false
  };

  componentDidMount () {
    const pathName = `${window.es_var.pathName}`;
    setTimeout(() => {
      if (pathName === 'fr-fr') {
        this.setState({
          showCallToAction: true
        });
      }
    }, 1000);

    if (this.getQueryStringValue('location')) {
      const Textlocation = decodeURIComponent(this.getQueryStringValue('location')).split(',');
      const newArr = Textlocation.map(this.ArrayCreateValueLabel);
      this.refs.LocationType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'location');
    }

    if (this.getQueryStringValue('country_code')) {
      const TextCountry = decodeURIComponent(this.getQueryStringValue('country_code')).split(',');
      const newArr = TextCountry.map(this.ArrayCreateValueLabelCountry);
      this.refs.CountryType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'countryCode');
    }

    if (this.getQueryStringValue('country_name')) {
      const TextCountryName = decodeURIComponent(this.getQueryStringValue('country_name')).split(',');
      const newArr = TextCountryName.map(this.ArrayCreateValueLabelCountry);
      this.refs.CountryType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'countryName');
    }

    if (this.getQueryStringValue('department')) {
      const TextDepartment = decodeURIComponent(this.getQueryStringValue('department')).split(',');
      const newArr = TextDepartment.map(this.ArrayCreateValueLabel);
      this.refs.DepartmentType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'department');
    }
    if (this.getQueryStringValue('contract_type')) {
      const TextContractType = decodeURIComponent(this.getQueryStringValue('contract_type')).split(',');
      const newArr = TextContractType.map(this.ArrayCreateValueLabel);
      this.refs.ContractType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'contract_type');
    }
    if (this.getQueryStringValue('sbu')) {
      const TextSBU = decodeURIComponent(this.getQueryStringValue('sbu')).split(',');
      const newArr = TextSBU.map(this.ArrayCreateValueLabel);
      this.refs.BusinessUnitsType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'business_units');
    }
    if (this.getQueryStringValue('professional_communities')) {
      const TextProfessionalCommunities = decodeURIComponent(this.getQueryStringValue('professional_communities')).split(',');
      const newArr = TextProfessionalCommunities.map(this.ArrayCreateValueLabel);
      this.refs.ProfessionalCommunitiesType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'professional_communities');
    }
    if (this.getQueryStringValue('brand')) {
      const TextBRAND = decodeURIComponent(this.getQueryStringValue('brand')).split(',');
      const newArr = TextBRAND.map(this.ArrayCreateValueLabel);
      this.refs.BrandType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'brand');
    }
    if (this.getQueryStringValue('experience_level')) {
      const TextExperienceLevel = decodeURIComponent(this.getQueryStringValue('experience_level')).split(',');
      const newArr = TextExperienceLevel.map(this.ArrayCreateValueLabel);
      this.refs.ExperienceLevelType.state.value = newArr;
      this.DefaultValueAdd(newArr, 'experience_level');
    }
    const urlParams = new URLSearchParams(window.location.search); // phpcs:ignore
    const myParam = urlParams.get('keyword');
    if (myParam) {
      this.setState({
        keyword: decodeURIComponent(myParam)
      });
    }
    if (this.getQueryStringValue('keyword')) {
      this.setState({
        keyword: decodeURIComponent(this.getQueryStringValue('keyword'))
      });
    }
    if (document.getElementById('hidden_keyword') !== undefined && document.getElementById('hidden_keyword') !== null) {
      const hidden_keyword = document.getElementById('hidden_keyword').value;
      if (hidden_keyword !== undefined && hidden_keyword !== '') {
        this.setState({
          keyword: hidden_keyword
        });
      }
    }
  }

  ArrayCreateValueLabelCountry (val) {
    const pre_defined_country_list = countryList;
    return { value: decodeURIComponent(val), label: pre_defined_country_list.find(({ key }) => key === val) !== undefined ? pre_defined_country_list.find(({ key }) => key === val).value : '' };
  }

  ArrayCreateValueLabel (val) {
    return { value: decodeURIComponent(val), label: decodeURIComponent(val) };
  }

  getQueryStringValue (key) {
    const urlParams = new URLSearchParams(window.location.search); // phpcs:ignore
    return urlParams.has(key) ? urlParams.get(key) : '';
  }

  onTitleChange = (event) => {
    this.setState({
      keyword: event.target.value
    });
  };

  // selected Value
  DefaultValueAdd = (selectedOptions, keyValue) => {
    let options = [];
    if (selectedOptions) {
      options = this.getSelectedOptions(selectedOptions);
    }
    if (options.length === 0) {
      const newState = this.state;
      newState[keyValue] = '';
      this.setState(newState);
    } else {
      if (keyValue == 'location') {
        this.setState({ location: options });
      }
      if (keyValue == 'countryCode') {
        // if (this.getQueryStringValue('country_name') === undefined || this.getQueryStringValue('country_name') === '') {
        //   this.handleClickCountryTags('');
        //   this.handleClickCountryTags('');
        // }
        let countriesNames = [];
        if (selectedOptions) {
          countriesNames = this.getSelectedOptions(selectedOptions, 'label');
        }
        this.setState({ countryCode: options, countryName: countriesNames });
      }
      if (keyValue == 'department') {
        this.setState({ department: options });
      }
      if (keyValue == 'contract_type') {
        this.setState({ contract_type: options });
      }
      if (keyValue == 'business_units') {
        this.setState({ business_units: options });
      }
      if (keyValue == 'experience_level') {
        this.setState({ experience_level: options });
      }
      if (keyValue == 'professional_communities') {
        this.setState({ professional_communities: options });
      }
      if (keyValue == 'brand') {
        this.setState({ brand: options });
      }
    }
  };

  // Countries
  CountriesSelect = (selectedOptions) => {
    let countries = [];
    if (selectedOptions) {
      countries = this.getSelectedOptions(selectedOptions);
    }

    let countriesNames = [];
    if (selectedOptions) {
      // selectedOptions.map(o =>
      //   countriesNames.push(o.label)
      // );

      countriesNames = this.getSelectedOptions(selectedOptions, 'label');
    }

    // if unchecked the same country and last one from dropdown
    if (countries.length === 0) {
      const newState = this.state;
      newState.countryCode = '';
      newState.countryName = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ countryCode: countries, countryName: countriesNames }, () => {
        this.props.onSearch(this.state.keyword, countries, countriesNames, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Location
  LocationSelect = (selectedOptions) => {
    let location = [];
    if (selectedOptions) {
      location = this.getSelectedOptions(selectedOptions);
    }

    if (location.length === 0) {
      const newState = this.state;
      newState.location = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ location }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Experience Level
  ExperienceLevelSelect = (selectedOptions) => {
    let experiencelevel = [];
    if (selectedOptions) {
      experiencelevel = this.getSelectedOptions(selectedOptions);
    }

    if (experiencelevel.length === 0) {
      const newState = this.state;
      newState.experience_level = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ experience_level: experiencelevel }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, experiencelevel, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Department
  DepartmentSelect = (selectedOptions) => {
    let department = [];
    if (selectedOptions) {
      department = this.getSelectedOptions(selectedOptions);
    }

    if (department.length === 0) {
      const newState = this.state;
      newState.department = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ department }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Contract type
  ContractTypeSelect = (selectedOptions) => {
    let contracttype = [];

    if (selectedOptions) {
      contracttype = this.getSelectedOptions(selectedOptions);
    }

    if (contracttype.length === 0) {
      const newState = this.state;
      newState.contract_type = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ contract_type: contracttype }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, contracttype, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Business Units
  BusinessUnitsSelect = (selectedOptions) => {
    let businessunits = [];
    if (selectedOptions) {
      businessunits = this.getSelectedOptions(selectedOptions);
    }

    if (businessunits.length === 0) {
      const newState = this.state;
      newState.business_units = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ business_units: businessunits }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, businessunits, this.state.location, this.state.brand, this.state.professional_communities);
      });
    }
  };

  // Professional communities
  ProfessionalCommunitiesSelect = (selectedOptions) => {
    let professional_communities = [];
    if (selectedOptions) {
      professional_communities = this.getSelectedOptions(selectedOptions);
    }

    if (professional_communities.length === 0) {
      const newState = this.state;
      newState.professional_communities = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    } else {
      this.setState({ professional_communities }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, professional_communities);
      });
    }
  };

  // Brand
  BrandSelect = (selectedOptions) => {
    let brands = [];
    if (selectedOptions) {
      brands = this.getSelectedOptions(selectedOptions);
    }

    if (brands.length === 0) {
      const newState = this.state;
      newState.brand = '';
      this.setState(newState);
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, brands, this.state.professional_communities);
    } else {
      this.setState({ brand: brands }, () => {
        this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, brands, this.state.professional_communities);
      });
    }
  };

  onSubmit = (event, keyword, countryCode, countryName, experience_level, department, contract_type, business_units, location, brand, professional_communities) => {
    event.preventDefault();
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickCountryTags = (param) => {
    /**
      saving the removed tags in a state to unselect from filter dropdown
    */
    // this.maintainRemovedTags(param);
    // var idx1 =this.refs.CountryType.state.selectValue.map(function (obj) { return obj.label; }).indexOf(param);
    // this.refs.CountryType.state.selectValue.splice( idx1, 1 );

    const currentValues = this.refs.CountryType.state.selectValue;
    // console.log('current values', currentValues);
    // console.log('param', param);
    const updatedValues = currentValues.filter(item => item.label != param);
    // console.log('updated values',updatedValues);
    this.refs.CountryType.setValue(updatedValues, 'set-value');
    // console.log(this.refs.CountryType.state,'checking current');

    let tempCountryCode = '';

    this.props.countries.forEach(function (element, index) {
      if (element.label === param) {
        tempCountryCode = element.value;
      }
    });

    // for more than one selection
    if (this.state.countryCode.length > 1) {
      // var idx1 = this.state.countryCode.indexOf(tempCountryCode)
      const remainingCountryCodes = this.state.countryCode.filter(item => item != tempCountryCode);

      // var idx2 = this.state.countryName.indexOf(param)
      const remainingCountryNames = this.state.countryName.filter(item => item != param);

      this.setState({
        countryCode: remainingCountryCodes,
        countryName: remainingCountryNames
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.countryCode = '';
      newState.countryName = '';
      this.setState(newState);
    }

    if (param !== '') {
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
    }
  };

  handleClickLocationTags = (param) => {
    // this.maintainRemovedTags(param);

    // var idx6 =this.refs.LocationType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.LocationType.state.selectValue.splice( idx6, 1 );

    const currentValues = this.refs.LocationType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.value != param);

    this.refs.LocationType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.location.length > 1) {
      // var idx6 = this.state.location.indexOf( param )
      // this.state.location.splice( idx6, 1 )

      // var idx2 = this.state.countryName.indexOf(param)
      const remaining = this.state.location.filter(item => item != param);
      this.setState({
        location: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.location = '';
      this.setState(newState);
    }

    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickExperienceTags = (param) => {
  //  this.maintainRemovedTags(param);
    // var idx3 =this.refs.ExperienceLevelType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.ExperienceLevelType.state.selectValue.splice( idx3, 1 );

    const currentValues = this.refs.ExperienceLevelType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.value != param);

    this.refs.ExperienceLevelType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.experience_level.length > 1) {
      // var idx3 = this.state.experience_level.indexOf( param )
      // this.state.experience_level.splice( idx3, 1 )
      const remaining = this.state.experience_level.filter(item => item != param);
      this.setState({
        experience_level: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.experience_level = '';
      this.setState(newState);
    }

    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickDepartmentTags = (param) => {
    // this.maintainRemovedTags(param);
    // var idx4 =this.refs.DepartmentType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.DepartmentType.state.selectValue.splice( idx4, 1 );

    const currentValues = this.refs.DepartmentType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.label != param);

    this.refs.DepartmentType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.department.length > 1) {
      // var idx4 = this.state.department.indexOf( param )
      // this.state.department.splice( idx4, 1 )
      const remaining = this.state.department.filter(item => item != param);
      this.setState({
        department: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.department = '';
      this.setState(newState);
    }
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickContractTags = (param) => {
  //  this.maintainRemovedTags(param);
    // var idx5 =this.refs.ContractType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.ContractType.state.selectValue.splice( idx5, 1 );
    const currentValues = this.refs.ContractType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.value != param);

    this.refs.ContractType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.contract_type.length > 1) {
      // let idx5 = this.state.contract_type.indexOf( param )
      // this.state.contract_type.splice( idx5, 1 )
      const remaining = this.state.contract_type.filter(item => item != param);
      this.setState({
        contract_type: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.contract_type = '';
      this.setState(newState);
    }
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickBusinessTags = (param) => {
    // this.maintainRemovedTags(param);
    // var idx6 =this.refs.BusinessUnitsType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.BusinessUnitsType.state.selectValue.splice( idx6, 1 );

    const currentValues = this.refs.BusinessUnitsType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.label != param);

    this.refs.BusinessUnitsType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.business_units.length > 1) {
      // var idx6 = this.state.business_units.indexOf( param )
      // this.state.business_units.splice( idx6, 1 )
      const remaining = this.state.business_units.filter(item => item != param);
      this.setState({
        business_units: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.business_units = '';
      this.setState(newState);
    }
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickProfessionalCommunitiesTags = (param) => {
    // this.maintainRemovedTags(param);
    // var idx7 =this.refs.ProfessionalCommunitiesType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.ProfessionalCommunitiesType.state.selectValue.splice( idx7, 1 );

    const currentValues = this.refs.ProfessionalCommunitiesType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.value != param);

    this.refs.ProfessionalCommunitiesType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.professional_communities.length > 1) {
      // var idx7 = this.state.professional_communities.indexOf( param )
      // this.state.professional_communities.splice( idx7, 1 )
      const remaining = this.state.professional_communities.filter(item => item != param);
      this.setState({
        professional_communities: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.professional_communities = '';
      this.setState(newState);
    }
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  handleClickBrandTags = (param) => {
    // this.maintainRemovedTags(param);
    // var idx6 =this.refs.BrandType.state.selectValue.map(function (obj) { return obj.value; }).indexOf(param);
    // this.refs.BrandType.state.selectValue.splice( idx6, 1 );

    const currentValues = this.refs.BrandType.state.selectValue;

    const updatedValues = currentValues.filter(item => item.value != param);

    this.refs.BrandType.setValue(updatedValues, 'set-value');

    // for more than one selection
    if (this.state.brand.length > 1) {
      // var idx6 = this.state.brand.indexOf( param )
      // this.state.brand.splice( idx6, 1 )
      const remaining = this.state.brand.filter(item => item != param);
      this.setState({
        brand: remaining
      });
    } else {
      // for single selection
      const newState = this.state;
      newState.brand = '';
      this.setState(newState);
    }
    this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities);
  };

  /** Clear All */
  handleClickClearAll = () => {
    const newState = this.state;

    for (const item in newState) {
      if (item !== 'keyword') {
        newState[item] = '';
      }
    }

    // this.setState( { removed_tags : "" } )
    this.refs.CountryType.clearValue();
    this.refs.LocationType.clearValue();
    this.refs.ExperienceLevelType.clearValue();
    this.refs.DepartmentType.clearValue();
    this.refs.ContractType.clearValue();
    this.refs.BusinessUnitsType.clearValue();
    this.refs.ProfessionalCommunitiesType.clearValue();
    this.refs.BrandType.clearValue();
    const size = 15;
    // this.setState({size: size});
    this.setState({
      ...newState,
      size,
      removed_tags: '',
      countryName: []
    }, () => {
      this.props.onSearch(this.state.keyword, this.state.countryCode, this.state.countryName, this.state.experience_level, this.state.department, this.state.contract_type, this.state.business_units, this.state.location, this.state.brand, this.state.professional_communities, size);
    });

    const pathName = `${window.es_var.pathName}`;

    if (pathName === 'fr-fr') {
      this.setState({
        showCallToAction: true
      });
    }
  };

  /**
    Maintaining removed tags
  */
  maintainRemovedTags = (tag) => {
    const closed_tags = this.state.removed_tags;
    closed_tags.push(tag);
    this.setState({ removed_tags: closed_tags });
  };

  /**
    Get Selection Options
  */
  getSelectedOptions = (chosenValues, optional = '') => {
    const removed_state = [];

    const final_selections = [];
    chosenValues.forEach(function (o, i) {
      /**
        if selected tag is found in removed state, ignore that element
      */

      // label is an exception used in countryNames used in jobstream query
      if (optional == 'label') {
        if (removed_state.indexOf(o.label) === -1) {
          final_selections.push(o.label);
        }
      } else {
        if (removed_state.indexOf(o.value) === -1) {
          final_selections.push(o.value);
        }
      }
    });

    return final_selections;
  };

  checkForTranslation = (label, filterType) => {
    const cg_jobs_translated_filters = `${window.cg_jobs_translated_filters_v1}` ? JSON.parse(`${window.cg_jobs_translated_filters_v1}`) : {};
    if (cg_jobs_translated_filters && filterType in cg_jobs_translated_filters && encodeURIComponent(label) in cg_jobs_translated_filters[filterType] && cg_jobs_translated_filters[filterType][encodeURIComponent(label)] !== '') {
      return cg_jobs_translated_filters[filterType][encodeURIComponent(label)];
    }

    return label;
  };

  render () {
    const _countries = this.props.countries;
    const _experiencelevel = this.props.experiencelevel;
    const _location = this.props.locations;
    const _department = this.props.department;
    const _contracttype = this.props.contracttype;
    const _businessunits = this.props.businessunits;
    const _professionalcommunities = this.props.professionalcommunities;
    const _brands = this.props.brand;
    const { selectedOption } = this.state;
    const _jobs = this.props.jobs;

    return (
      <section className="archive-pages">
        <header className="header header--sub2 header--search">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8 offset-lg-2">
                <h1 className="box-title">{ __('Job Search', 'macs-react-jobs') }</h1>
                <form className="form--oneliner" onSubmit={this.onSubmit}>
                    <div className="form-block">
                     <label htmlFor="searchsubmit" className="sr-only">{ __('Job Search', 'macs-react-jobs') }</label>
                      <input
                        id="searchsubmit"
                        value={this.state.keyword}
                        onChange={this.onTitleChange}
                        name="search_term"
                        type="text"
                        placeholder={ __('Enter job name or reference id', 'macs-react-jobs') }
                        className="empty"
                      />
                    </div>
                    <div className="button-wrapper">
                      <input
                        className="search-button"
                        type="submit"
                        value=""
                        role="presentation"
                        aria-label="Submit job search button"
                      />
                    </div>
                </form>
              </div>
            </div>
          </div>
          <div className="header-shape"></div>
        </header>

        <div id="anchor"></div>
        <div id="job_search_list" className="container filters-container">

          <div className="content-title">

            { _jobs?.total > 0 &&
              <h2>{ __('Rewrite your future. Search and apply for a job today.', 'macs-react-jobs') }</h2>
            }

          </div>

        { this.state.showCallToAction &&

          <div className="call-to-action">
              <div className="col-md-8 col-lg-7 col-12">
                <h4>  Nous avons l&apos;opportunité qui vous ressemble, matchez votre CV et découvrez nos offres.</h4>
              </div>
              <div className="col-md-4 col-lg-5 col-12">
              <div className="fr-button"> <a className="cta-btn" href="https://capgemini.hrmatch.com/jobs/matching/resume" target="_blank"
              rel="noopener noreferrer" title="Opens in a new window" > Déposez votre CV</a></div>
              </div>
          </div>
        }

          <div className="filters filters--table">
            <div className="filters-selects-label filter-jobs-label" role="button" aria-label='Filter Results'>
              <span className="d-none d-md-inline">
                { __('Filters', 'macs-react-jobs') }
              </span>
               <span className="d-inline d-md-none">
                { __('Filter results', 'macs-react-jobs') }
              </span>
            </div>
            <div className="row filters-selects-list">
              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('country') == true ? 'block' : 'none' }}>
                <label htmlFor="country-select" className="sr-only">{ __('Country', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  // value={this.state.countryCode}
                  ref="CountryType"
                  onChange={this.CountriesSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_countries}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Country', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='country-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search"/>

              </div>
              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('location') == true ? 'block' : 'none' }}>
                <label htmlFor="location-select" className="sr-only">{ __('Location', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="LocationType"
                  onChange={this.LocationSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_location}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Location', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='location-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search" />
              </div>
              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('experience_level') == true ? 'block' : 'none' }}>
                <label htmlFor="experience-select" className="sr-only">{ __('Experience Level', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  ref="ExperienceLevelType"
                  value={selectedOption}
                  onChange={this.ExperienceLevelSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_experiencelevel}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Experience Level', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='experience-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search"/>
              </div>

              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('department') == true ? 'block' : 'none' }}>
                <label htmlFor="department-select" className="sr-only">{ __('Department', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="DepartmentType"
                  onChange={this.DepartmentSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_department}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Department', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='department-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search" />
              </div>

              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('contract_type') == true ? 'block' : 'none' }}>
                <label htmlFor="contract-select" className="sr-only">{ __('Contract Type', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="ContractType"
                  onChange={this.ContractTypeSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_contracttype}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Contract Type', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='contract-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search"/>
              </div>

              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('business_units') == true ? 'block' : 'none' }}>
                <label htmlFor="business-unit-select" className="sr-only">{ __('Business Units', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="BusinessUnitsType"
                  onChange={this.BusinessUnitsSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_businessunits}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Business Units', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='business-unit-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search"/>
              </div>

              <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('professional_communities') == true ? 'block' : 'none' }}>
                <label htmlFor="professional-communities-select" className="sr-only">{ __('Professional communities', 'macs-react-jobs') }</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="ProfessionalCommunitiesType"
                  onChange={this.ProfessionalCommunitiesSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_professionalcommunities}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Professional communities', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='professional-communities-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search"/>
              </div>

            <div className="filters-selects-box filters-selects-box-jobs" data-filter="" style={{ display: (this.props.filtersdata).includes('brand') == true ? 'block' : 'none' }}>
                <label htmlFor="brand-select" className="sr-only">Brand</label>
                <Select
                  name="form-field-name"
                  value={selectedOption}
                  ref="BrandType"
                  onChange={this.BrandSelect}
                  clearable={this.state.clearable}
                  searchable={this.state.searchable}
                  isMulti = {true}
                  styles = {customStyles}
                  options = {_brands}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null, ClearIndicator: () => null }}
                  className='macsrj-select'
                  classNamePrefix='react-select'
                  labelKey='label'
                  valueKey='value'
                  placeholder={ __('Brands', 'macs-react-jobs') }
                  hideSelectedOptions={false}
                  controlShouldRenderValue = {false}
                  isSearchable={false}
                  inputId='brand-select'
                />
                <input type="hidden" name="" value="" />
                <input type="submit" className="filters-search-submit form__block" value="" aria-label="Submit search" />
              </div>
           </div>
            <div className="filters-tags-wrapper">
              <div className="filters-tags-list">

              {
                this.state.countryName.length > 0 && (this.state.countryName).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={0}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickCountryTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{item}</span>
                    </span>
                )
                )
              }

              {
                this.state.experience_level.length > 0 && (this.state.experience_level).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={1}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickExperienceTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{this.checkForTranslation(item, 'experience_level')}</span>
                    </span>
                )
                )
              }
              {
                this.state.department.length > 0 && (this.state.department).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={2}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickDepartmentTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{item}</span>
                    </span>
                )
                )
              }

              {
                this.state.contract_type.length > 0 && (this.state.contract_type).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={3}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickContractTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{this.checkForTranslation(item, 'contract_type')}</span>
                    </span>
                )
                )
              }

              {
                this.state.business_units.length > 0 && (this.state.business_units).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={4}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickBusinessTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{item}</span>
                    </span>
                )
                )
              }

              {
                this.state.professional_communities.length > 0 && (this.state.professional_communities).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={4}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickProfessionalCommunitiesTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{this.checkForTranslation(item, 'professional_communities')}</span>
                    </span>
                )
                )
              }

              {
                this.state.brand.length > 0 && (this.state.brand).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={7}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickBrandTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{this.checkForTranslation(item, 'brand')}</span>
                    </span>
                )
                )
              }
              {
                this.state.location.length > 0 && (this.state.location).map((item, i) => (
                    <span key={i} className="filters-tag" data-filter={6}>
                    <button className="filters-tag-remove" aria-label={`close ${item}`} onClick={() => this.handleClickLocationTags(item)} >
                        <i className="icon-close" aria-hidden="true"></i>
                      </button>
                      <span>{this.checkForTranslation(item, 'location')}</span>
                    </span>
                )
                )
              }
              {
                (this.state.countryName.length > 0 || this.state.experience_level.length > 0 || this.state.department.length > 0 || this.state.contract_type.length > 0 || this.state.business_units.length > 0 || this.state.location.length > 0 || this.state.professional_communities.length > 0 || this.state.brand.length > 0) &&

                <button className="filters-tag-remove filters-tag remove-all-tags" aria-label="Clear all" data-filter={5} onClick={() => this.handleClickClearAll()}>
                { __('Clear all', 'macs-react-jobs') }
                </button>
              }
              </div>
            </div>

            {
              window.es_var.pathName === '' && this.state.countryName.length === 1 &&
                (
                  <LocalCountryPage keyword={this.state.keyword} countryName={this.state.countryName[0]}/>
                )
              }

          </div>
        </div>
      </section>
    );
  }
}

export default Search;

Search.propTypes = {
  onSearch: PropTypes.func,
  countries: PropTypes.any,
  experiencelevel: PropTypes.any,
  department: PropTypes.any,
  contactType: PropTypes.any,
  contracttype: PropTypes.any,
  businessunits: PropTypes.any,
  locations: PropTypes.any
};
